import { createContext } from 'react'

import { createToolbarStore } from '../store/createStore'

export const ToolbarStoreContext = createContext<
  ReturnType<typeof createToolbarStore> | undefined
>(undefined)
